import React from 'react'
import { ConfirmationDialog } from '../../Components/ConfirmationDialog'
import { ChildProps, graphql } from 'react-apollo'
import {
  getAllInstreamPlacementCollectionSummariesQuery,
  InstreamPlacementCollectionSummaryResponse,
  deleteInstreamPlacementCollection,
} from '../../Api/instreamPlacements_v2'
import { get } from 'lodash'
import { SessionContext } from '../../Contexts/SessionContext'

interface State {
  isSubmitting: boolean
  hasError: boolean
}

interface InputProps {
  collectionId: string
  onClose: () => void
  onUpdated: () => void
}

export class DeleteInstreamPlacementCollectionDialogView extends React.Component<
  ChildProps<InputProps, InstreamPlacementCollectionSummaryResponse>,
  State
> {
  static contextType = SessionContext
  context!: React.ContextType<typeof SessionContext>

  constructor(props: any) {
    super(props)
    this.state = {
      isSubmitting: false,
      hasError: false,
    }
  }
  render() {
    if (!this.getCollection()) {
      return <React.Fragment />
    }
    return (
      <ConfirmationDialog
        dialogTitle="Delete Instream Collection"
        confirmationText={`Are you sure you want to delete instream placement collection "${this.getCollection()!.title}"?`}
        errorMessage={
          this.state.hasError
            ? 'Could not delete collection. If the problem persist, please contact support.'
            : undefined
        }
        yesButtonText="Yes"
        noButtonText="No"
        isLoading={this.state.isSubmitting}
        onCancel={this.props.onClose}
        onConfirm={() => this.submit()}
      />
    )
  }
  submit() {
    this.setState({ isSubmitting: true })
    deleteInstreamPlacementCollection(this.props.collectionId)
      .then(this.props.onUpdated)
      .then(() => {
        window.location.href = `${process.env.PUBLIC_URL}/#/${this.context.ctok}/instream-placements/#/nav/instream-placements_v2/open`
        this.props.onClose()
      })
      .catch((e) => {
        console.error(e)
        this.setState({ isSubmitting: false, hasError: true })
      })
    return false
  }
  getCollection() {
    return get(this.props.data!, 'instreamPlacementCollections_v2', []).find(
      (c) => c.id === this.props.collectionId
    )
  }
}

const withGql = graphql<InputProps, InstreamPlacementCollectionSummaryResponse>(
  getAllInstreamPlacementCollectionSummariesQuery,
  { options: () => ({ notifyOnNetworkStatusChange: true }) }
)
export const DeleteInstreamPlacementCollectionDialog = withGql(
  DeleteInstreamPlacementCollectionDialogView
)
